import urlConditional from "./apiInfo";
const location = urlConditional();
// const location = "https://www.g2g-api.com"

const ProductsManager = {
  getProducts(pageNumber = "all", category = "all", searchTerm = "") {
    return fetch(
      `${location}/products?page=${pageNumber}&category=${category}&searchTerm=${searchTerm}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      }
    ).then((resp) => resp.json());
  },
  getProductTypes() {
    return fetch(`${location}/product-types`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(),
    }).then((resp) => resp.json());
  },
  async addProductToCart(productId, product) {
    const resp = await fetch(`${location}/orders/${productId}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Token ${sessionStorage.getItem("token")}`,
      },
      body: JSON.stringify({ product }),
    });
    return await resp.json();
  },
  async getProductDetail(productId) {
    const resp = await fetch(`${location}/products/${productId}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        // Authorization: `Token ${sessionStorage.getItem("token")}`,
      },
    });
    return await resp.json();
  },
  // Taking in a form data object
  postSellableProduct(product) {
    return fetch(`${location}/lend`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: `Token ${sessionStorage.getItem("token")}`,
      },
      body: product,
    }).then((resp) => resp.json());
  },
  updateProduct(productId, updatedProduct) {
    return fetch(`${location}/products/${productId}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${sessionStorage.getItem("token")}`,
      },
      body: JSON.stringify(updatedProduct),
    }).then((resp) => resp.json());
  },
  getProduct(productId) {
    return fetch(`${location}/products/${productId}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    }).then((resp) => resp.json());
  },
  patchProduct(patchProductId, quant) {
    return fetch(`${location}/products/${patchProductId}`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${sessionStorage.getItem("token")}`,
      },
      body: JSON.stringify({ quantity: quant }),
    });
    // .then(resp => resp.json())
  },
  deleteGear(gearId) {
    return fetch(`${location}/products/${gearId}`, {
      method: "DELETE",
      headers: {
        Authorization: `Token ${sessionStorage.getItem("token")}`,
      },
    });
  },
  getLenderGear(lenderId) {
    return fetch(`${location}/lenderproducts/${lenderId}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Token ${sessionStorage.getItem("token")}`,
      },
    }).then((resp) => resp.json());
  },
};

export default ProductsManager;
